<template>
  <div class="user-info page">
    <div class="page-inner">
      <v-form ref="form">
        <CommonForm ref="refCommonForm" :userData="userData" />

        <div class="bottom-btn">
          <v-btn
            color="primary"
            x-large
            depressed
            block
            rounded
            @click="clickSave"
          >
            정보수정 하기
          </v-btn>
        </div>
      </v-form>
    </div>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CommonForm from "../signUp/comp/CommonForm.vue";
const modelService = require("@/utils/dataModel.js");
const rulesService = require("@/utils/rules.js");
import ConfirmDialog from "@/_bayer/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    CommonForm,
    ConfirmDialog,
  },
  data() {
    return {
      userData: modelService.userModel(),
      emailIdRules: rulesService.emailIdRules(),
    };
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  mounted() {
    const $h = this.$helper;
    this.getMeInfo().then(() => {
      console.log("me", this.meInfo.email);
      if (this.meInfo.email !== "" && this.meInfo.email !== null) {
        this.meInfo.emailId = $h.changeEmailIdDomainType(
          this.meInfo.email,
          "id"
        );
        this.meInfo.emailDomain = $h.changeEmailIdDomainType(
          this.meInfo.email,
          "domain"
        );
        this.meInfo.emailDomainType = $h.changeEmailIdDomainType(
          this.meInfo.email,
          "type"
        );
      }
      this.userData = this.meInfo;
    });
  },
  methods: {
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;
      const objRF = RF.refCommonForm.$refs;

      let msg = `입력하신 정보를 다시 확인해주세요. 표시된 안내에 따라 입력해주세요.`;
      if (!RF.form.validate()) {
        $h.showTostMessage("", msg, "error");
        return;
      }

      let tObj = null;
      msg = `연령대를 선택해주세요`;
      if (!$h.requiredCheck(DT.birthdayType, null, msg, false)) return;

      console.log(
        "this.emailIdRules.check2(DT.emailId)",
        this.emailIdRules.check2(DT.emailId)
      );

      if (DT.emailId !== "" && !this.emailIdRules.check2(DT.emailId)) {
        msg = `올바른 이메일 형식이 아닙니다.`;
        $h.showTostMessage("", msg, "error");
        objRF.refUserForm.$refs.refEmailForm.$refs.refEmailId.focus();
        return;
      }

      if (DT.emailDomain !== "" && !this.emailIdRules.check2(DT.emailDomain)) {
        msg = `올바른 이메일 형식이 아닙니다.`;
        $h.showTostMessage("", msg, "error");
        objRF.refUserForm.$refs.refEmailForm.$refs.refEmailDomain.focus();
        return;
      }

      msg = `자택주소를 검색 해주세요`;
      console.log("DT", DT);
      if (!this.isAuthorized && !DT.isAddressSearch) {
        $h.showTostMessage("", msg, "info");
        objRF.refAddress.$refs.refZipcode.focus();
        return;
      }

      msg = `자택주소 상세주소를 입력해주세요 해주세요`;
      tObj = objRF.refAddress.$refs.refStreet;
      if (!$h.requiredCheck(DT.address.street, tObj, msg)) return;

      msg = `주요 재배 작물(1)과 재배면적을 입력해 주세요`;
      tObj = objRF.refFarmForm.$refs.refCropsFrom1.$refs.refCrops;
      if (!$h.requiredCheck(DT.farm.crops1, tObj, msg)) return;

      tObj = objRF.refFarmForm.$refs.refCropsFrom1.$refs.refCropArea;
      if (!$h.requiredCheck(DT.farm.areaSize1, tObj, msg)) return;

      msg = `주요 재배 작물(2)과 재배면적을 입력해 주세요`;
      tObj = objRF.refFarmForm.$refs.refCropsFrom2.$refs.refCrops;
      if (!$h.requiredCheck(DT.farm.crops2, tObj, msg)) return;

      tObj = objRF.refFarmForm.$refs.refCropsFrom2.$refs.refCropArea;
      if (!$h.requiredCheck(DT.farm.areaSize2, tObj, msg)) return;

      DT.email = DT.emailId + "@" + DT.emailDomain;

      console.log("DT", DT);
      // return;
      // if (!confirm("회원정보를 수정하시겠습니까?")) return;
      this.$refs.refConfirmDialog.open("회원정보를 수정하시겠습니까?");
    },
    clickPopupConfirm() {
      const $h = this.$helper;
      const DT = this.userData;
      this.userData.endpoint = "meUpdate";
      this.userData.endpointUser = "user";
      this.saveDataQuery(this.userData).then((res) => {
        console.log("res", res);
        if (res === undefined) return;
        this.$helper.showTostMessage(
          "",
          "개인정보 수정이 완료 되었습니다.",
          "success"
        );
        // this.$refs.refCommonDialog.open("개인정보 수정이 완료 되었습니다");

        this.signOut();
        this.$router.push("/login");
      });
    },
    clickPopupOk() {},
    ...mapActions(["getMeInfo", "saveDataQuery", "signOut"]),
  },
};
</script>
<style lang="scss">
@media (min-width: 769px) {
  div.user-info {
    .bottom-btn {
      padding: 20px calc((100% - 600px) / 2);
    }
  }
}
.user-info {
  position: relative;
  padding-bottom: 100px;

  .bottom-btn {
    background: #f3f3f3;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 20px;
    // box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
  }
}
</style>